/**
 * Author: Aldrin
 * Description: {Providing Service} to dependency-based navigation flow between quality modules.
 * Created On: 2025-Nov-20
 */

import { EventEmitter, Injectable } from '@angular/core';
import { NavigationContext } from '../models/navigation-context.model';

@Injectable({
  providedIn: 'root'
})
export class DependencyNavigationService {

  /* Flag to trigger a manual refresh when navigating within the same module.
    Since ngOnInit won’t fire for same-module transitions (e.g., CR → CR),
    this emitter forces the quality module to reload its data. */
  public readonly refresh = new EventEmitter<void>();

  constructor() { }

  private stack: NavigationContext[] = [];

  /*  Use this method to track dependency navigation. This will push data into stack.
      Store the relevant primary keys from qualityService so the user can navigate back correctly. */
  push(context: NavigationContext): void {
    this.stack.push(context);
  }

  /*  Use this method to remove the top item from the navigation stack. 
     It returns the popped context, which should be mapped to the corresponding keys in qualityService. */
  pop(): NavigationContext | undefined {
    const popped = this.stack.pop();
    return popped;
  }

  /*  isTriggeredFromDependencies indicates whether the navigation originated from a dependency workflow. 
  The peek value toggles this flag so the back-navigation logic knows whether to route back between dependencies or override the dependency route. */
  peek(): NavigationContext | undefined {
    return this.stack.at(-1);
  }

  clear(): void {
    this.stack = [];
  }

  public getStackSize(): number {
    return this.stack.length;
  }
}
